import axios from 'axios';
import http from '../utils/http';

const instance = axios.create();

instance.interceptors.response.use(undefined, error => http.interceptError(error, instance));

export default instance;



// WEBPACK FOOTER //
// ./src/modules/auth/axios.js